import * as React from 'react';
import merge from 'lodash/merge';

import { VALID_ICONS } from '../../Icon/SVGIcon';

import ListItem, { IListItemProps } from './ListItem';
import { StyledList } from './ListStyles';

export const BULLETS: string = 'bullets';
export const ICONS: string = 'icons';
export const NUMBERS: string = 'numbers';
const DEFAULT_LIST_STYLE_PROPS = { color: 'black', type: BULLETS };

export type VALID_LIST_STYLES =
  | typeof BULLETS
  | typeof ICONS
  | typeof NUMBERS;

// tslint:disable:no-reserved-keywords
export interface IListProps {
  listStyleProps: {
    type?: VALID_LIST_STYLES;
    color?: string;
  };
  iconProps?: {
    type?: VALID_ICONS;
    size?: string;
  };
}
// tslint:enable:no-reserved-keywords

export const ListContext: React.Context<IListProps> =
  React.createContext<IListProps>({ iconProps: undefined, listStyleProps: DEFAULT_LIST_STYLE_PROPS });

export const List: React.FC<Partial<IListProps>> & { Item: React.FC<IListItemProps> } = ({
  listStyleProps = { type: BULLETS, color: 'black' },
  iconProps,
  children
}) => {
  const listStylePropsMerged = merge(DEFAULT_LIST_STYLE_PROPS, listStyleProps);

  return (
    <ListContext.Provider value={{ iconProps, listStyleProps }}>
      <StyledList listStyle={listStylePropsMerged.type}>
        {children}
      </StyledList>
    </ListContext.Provider>
  );
};

List.Item = ListItem;

export default List;
